import React, { PropsWithChildren } from 'react';

export type TagListProps = PropsWithChildren<{}>;

export const TagList = ({ children }: TagListProps) => (
  <ul className="flex flew-row flex-wrap text-xs text-gray-400 uppercase font-bold tracking-wider mb-2">
    {children}
  </ul>
);
